import { CollapsibleRowMenuButton } from 'components/collapsible-row-menu';
import t from 'react-translate';
import { config } from '@config/pendo.config.json';
import NvTooltip from 'shared/components/nv-tooltip';
import React, { useCallback, useMemo } from 'react';

export enum ToggleQuestionTypes {
  GENERAL = 'GENERAL',
  PERSONALIZE = 'PERSONALIZE',
}

const ToggleQuestionTypeButtonIcons = {
  [ToggleQuestionTypes.GENERAL]: 'diverge',
  [ToggleQuestionTypes.PERSONALIZE]: 'converge',
};

type ToggleQuestionTypeButtonProps = {
  mode?: ToggleQuestionTypes;
  onClick: (type: ToggleQuestionTypes) => void;
};

const ToggleQuestionTypeButton = (props: ToggleQuestionTypeButtonProps) => {
  const {
    mode = ToggleQuestionTypes.GENERAL,
    onClick,
  } = props;

  const handleToggle = useCallback(() => {
    const newMode = mode === ToggleQuestionTypes.GENERAL
      ? ToggleQuestionTypes.PERSONALIZE
      : ToggleQuestionTypes.GENERAL;
    onClick(newMode);
  }, [mode, onClick]);

  const icon = useMemo(() => ToggleQuestionTypeButtonIcons[mode], [mode]);
  const translations = useMemo(() => (
    t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_PROFILE_SETUP.PROGRAM_LEVEL_FIELDS.SWITCH_QUESTION_TYPE
  ), []);
  const dataQa = useMemo(() => (
    config.pendo.athena.mentorshipProgram.settings.programProfileSetup.toggleQuestionTypeButton ?? ''
  ), []);

  return (
    <NvTooltip
      text={translations[mode].TOOLTIP()}
      placement='top'
      maxWidth={240}
    >
      <div className='d-flex'>
        <CollapsibleRowMenuButton
          icon={icon}
          onClick={handleToggle}
          data-qa={dataQa}
          aria-label={translations[mode].ARIA_LABEL()}
        />
      </div>
    </NvTooltip>
  );
};

export default React.memo(ToggleQuestionTypeButton);
